export default __webpack_public_path__ + "static/media/whatCanISay.363da625.png";